const routePaths = {
    root: '/',
    landingPage: '/home',   
    signIn: '/signIn',
    signInCallback: '/signin/complete',
    interactiveWorkspace: '/home', 
    Unauthorized: '/unAuthorized',
    documentPage: '/documentPage',
    auditTrailPage: '/audit-trail'
}

export default routePaths;